import React from "react";
import ExchangeTable from "../components/ExchangeTable";
const Exchanges = () => {
  return (
    <div>
      <ExchangeTable />
    </div>
  );
};

export default Exchanges;
